import store from '@/store'

export const getUserAccessToken = () => {
  const accessToken = store.getters['User/accessToken']
  const tokenExpire = store.getters['User/tokenExpire']
  const dateTime = new Date().getTime()
  if (!accessToken || !tokenExpire || tokenExpire <= dateTime) {
    store.dispatch('User/logout')
    return null
  }
  return accessToken
}

export const getUserAuthToken = () => {
  let token = {}
  const accessToken = getUserAccessToken()
  if (accessToken) {
    token = {
      key: 'Authorization',
      value: `Bearer ${accessToken}`
    }
  }
  return token
}

export const getClinicAccessToken = () => {
  const accessToken = store.getters['Clinic/accessToken']
  const tokenExpire = store.getters['Clinic/tokenExpire']
  const dateTime = new Date().getTime()
  if (!accessToken || !tokenExpire || tokenExpire <= dateTime) {
    store.dispatch('Clinic/logout')
    return null
  }
  return accessToken
}

export const getClinicAuthToken = () => {
  let token = {}
  const accessToken = getClinicAccessToken()
  if (accessToken) {
    token = {
      key: 'Authorization',
      value: `Bearer ${accessToken}`
    }
  }
  return token
}

export const getBranchAccessToken = () => {
  const accessToken = store.getters['Branch/accessToken']
  const tokenExpire = store.getters['Branch/tokenExpire']
  const dateTime = new Date().getTime()
  if (!accessToken || !tokenExpire || tokenExpire <= dateTime) {
    store.dispatch('Branch/resetBranch')
    return null
  }
  return accessToken
}

export const getBranchAuthToken = () => {
  let token = {}
  const accessToken = getBranchAccessToken()
  if (accessToken) {
    token = {
      key: 'Authorization',
      value: `Bearer ${accessToken}`
    }
  }
  return token
}

export const getRole = () => {
  let role = ''
  const data = store.getters['Branch/branch']
  if (data) {
    const { role: branchRole } = data
    role = branchRole
  }
  return role
}

export default {
  getUserAccessToken,
  getUserAuthToken,
  getClinicAccessToken,
  getClinicAuthToken,
  getBranchAccessToken,
  getBranchAuthToken,
  getRole
}
